export default "__VITE_ASSET__a18c1e9e__"